import React from "react";
import Button from "./Button";

const ModalFormButtons = (props) => {
    return (
        <div className="bg-gray-50 rounded-b-2xl px-6 py-4 flex flex-row-reverse">
            <Button isSubmit={true} title={props.saveTitle} handleClick={props.handleCancelClick}/>
            <Button bgColor="white" color="black" title="Cancel" handleClick={props.handleCancelClick}/>
        </div>
    );
}

export default ModalFormButtons;
